<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {
            trackBy: 'id',

            provider: null,
            initProvider: [],
            providers_option: [],

            voice_id: null,
            initVoiceID: [],
            voices_id_option: [],

            language: null,
            initLanguages: [],
            languages_option: [],

            emotion: null,
            initEmotion: [],
            emotions_option: []
        }
    },

    watch: {
        initProvider: {
            immediate: true,
            handler(values) {
                this.provider = this.providers_option.filter(x => values.includes(x['operator_uuid']));
                this.provider = this.provider[0];
            }
        },
        initVoiceID: {
            immediate: true,
            handler(values) {
                this.voice_id = this.voices_id_option.filter(x => values.includes(x['voice_id']));
                this.voice_id = this.voice_id[0];
            }
        },
        initEmotion: {
            immediate: true,
            handler(values) {
                this.emotion = this.emotions_option.filter(x => values.includes(x[this.trackBy]));
                this.emotion = this.emotion[0];
            }
        },
        initLanguages: {
            immediate: true,
            handler(values) {
                this.language = this.languages_option.filter(x => values.includes(x[this.trackBy]));
                this.language = this.language[0];
            }
        },
        provider: {
            immediate: true,
            async handler(values) {

                if(this.provider){
                    this.$parent.tts_params.provider = this.provider.operator_code ? this.provider.operator_code : null;
                    this.$parent.tts_params.provider_uuid = this.provider.operator_uuid ? this.provider.operator_uuid : null;

                    let filter = {
                        'operator_uuid' : this.$parent.tts_params.provider_uuid,
                        'product_code'  : this.$parent.tts_params.product_code,
                    }
                    let data_send = {
                        'where' : JSON.stringify(filter)
                    }

                    await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);
                    this.voices_id_option = this.operators_tariffs_list_data;

                    if(this.$parent.tts_params.id && this.$parent.tts_params.id) {
                        this.initVoiceID = [this.$parent.tts_params.id];
                    }

                } else if(values === null) {
                    this.voices_id_option = [];
                    this.languages_option = [];
                    this.emotions_option  = [];
                    this.voice_id = null;
                    this.$parent.tts_params.provider = null;
                    this.$parent.tts_params.provider_uuid = null
                }
            }
        },
        voice_id: {
            immediate: true,
            async handler(values) {
                if(this.voice_id && this.voice_id.voice_id) {
                    this.$parent.tts_params.id = this.voice_id.voice_id ? this.voice_id.voice_id : null;

                    this.languages_option = this.get_options(this.voice_id.languages);
                    this.initLanguages = [this.$parent.tts_params.language];

                    this.emotions_option = this.get_options(this.voice_id.emotions);
                    if(Array.isArray(this.emotions_option) && this.emotions_option.length > 0){
                        this.initEmotion = [this.$parent.tts_params.emotion];
                    } else {
                        this.emotion = null;
                    }
                    

                } else if(values === null) {
                    this.$parent.tts_params.id = null;
                    this.languages_option = [];
                    this.emotions_option  = [];
                    this.language = null;
                    this.emotion  = null;
                }
            }
        },
        language: {
            immediate: true,
            handler(values) {
                if(this.language && this.language.id) {
                    this.$parent.tts_params.language = this.language.id ? this.language.id : null;
                } else if(values === null) {
                    this.$parent.tts_params.language = null;
                }
            }
        },
        emotion: {
            immediate: true,
            handler(values) {
                if(this.emotion && this.emotion.id) {
                    this.$parent.tts_params.emotion = this.emotion.id ? this.emotion.id : null;
                } else if(values === null){
                    this.$parent.tts_params.emotion = null;
                }
            }
        },
    },

    computed: {
        operators_tariffs_list_data(){
            return this.$store.getters['operatorsTariffs/GET_OPERATORS_TARIFFS_LIST_DATA'];
        },
    },

    async mounted() {

        let data_send = {
            'filter'     : this.$parent.params.tts_params.product_code ? this.$parent.params.tts_params.product_code : this.$parent.tts_params.product_code,
            'filterOn'   : JSON.stringify(['product_code']),
            'get_fields' : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
            'groupBy'    : JSON.stringify(['operator_code', 'operator_name', 'operator_uuid', 'product_code']),
        }

        await this.$store.dispatch('operatorsTariffs/FETCH_OPERATORS_TARIFFS_LIST', data_send);

        this.providers_option = this.operators_tariffs_list_data;

        if(this.$parent.params.tts_params && this.$parent.params.tts_params.provider_uuid) {
            this.initProvider = [this.$parent.params.tts_params.provider_uuid];
        }

    },

    methods: {
        get_options(arr = []){

            let arr_options = [];

            let name_translate = {
                'ru-RU'   : 'Русский',
                'kk-KK'   : 'Казахский',
                'neutral' : 'Нейтральный',
                'good'    : 'Добрый',
                'evil'    : 'Злой'
            }

            arr.forEach(el => {
                arr_options.push({
                    id: el,
                    name: name_translate[el] ? name_translate[el] : el
                });
            })

            return arr_options;
        }
    }
}
</script>

<template>
    <div>

        <div class="row">
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="Провайдер"
                    label-for="provider"
                >
                    <multiselect
                        id="provider"
                        v-model="provider"
                        :options="providers_option"
                        placeholder="Выберите из списка"
                        selectLabel="Нажмите, чтобы выбрать"
                        deselectLabel="Нажмите, снять выделение"
                        label="operator_name"
                        track-by="operator_uuid"
                    ></multiselect>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-6">
                <b-form-group
                    label="Голос"
                    label-for="provider"
                >
                    <multiselect
                        id="voice_id"
                        v-model="voice_id"
                        :options="voices_id_option"
                        placeholder="Выберите из списка"
                        selectLabel="Нажмите, чтобы выбрать"
                        deselectLabel="Нажмите, снять выделение"
                        label="name"
                        track-by="voice_id"
                    ></multiselect>
                </b-form-group>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-xl-4" v-show="languages_option.length > 0">
                <b-form-group
                    label="Язык"
                    label-for="language"
                >
                    <multiselect
                        id="language"
                        v-model="language"
                        :options="languages_option"
                        placeholder="Выберите из списка"
                        selectLabel="Нажмите, чтобы выбрать"
                        deselectLabel="Нажмите, снять выделение"
                        label="name"
                        :track-by="trackBy"
                    ></multiselect>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-4" v-show="emotions_option.length > 0">
                <b-form-group
                    label="Эмоции"
                    label-for="emotion"
                >
                    <multiselect
                        id="emotion"
                        v-model="emotion"
                        :options="emotions_option"
                        placeholder="Выберите из списка"
                        selectLabel="Нажмите, чтобы выбрать"
                        deselectLabel="Нажмите, снять выделение"
                        label="name"
                        :track-by="trackBy"
                    ></multiselect>
                </b-form-group>
            </div>
            <div class="col-sm-12 col-xl-4">
                <b-form-group
                    label="Скорость"
                    label-for="speed"
                >
                    <b-form-input
                        id="speed"
                        v-model="$parent.tts_params.speed"
                    ></b-form-input>
                </b-form-group>
            </div>
        </div>

        <b-form-group
            label="Текст для озвучки"
            label-for="text"
        >
            <b-form-textarea
                id="text"
                v-model="$parent.text"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            label="Переменная для сохранения результата"
            label-for="tts_params_variable_name"
        >
            <b-form-input
                id="tts_params_variable_name"
                v-model="$parent.tts_params.variable_name"
            ></b-form-input>
        </b-form-group>

    </div>
</template>
